import { FC, ReactNode } from 'react';
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/pro-regular-svg-icons';
import { BoxV2 as Box, Flex } from 'portal-commons';

import Divider from './Divider';

interface RcsSectionBlockProps {
  icon?: FontAwesomeIconProps['icon'];
  title: string;
  showDivider?: boolean;
  editable?: boolean;
  onEditClick?: () => void;
  'data-testid'?: string;
  headerAside?: ReactNode;
}

const RcsSectionBlock: FC<RcsSectionBlockProps> = ({
  icon,
  title,
  showDivider = true,
  children,
  editable = false,
  onEditClick,
  'data-testid': dataTestId,
  headerAside,
}) => {
  return (
    <Flex
      as="section"
      sx={{
        flexDirection: 'column',
        paddingY: 'xl',
        paddingX: 'xxl',
        border: '1px solid',
        borderColor: 't.black20',
        backgroundColor: 't.white',
      }}
      data-testid={dataTestId ?? 'rcsSection'}
    >
      <Flex
        sx={{
          alignItems: 'center',
          flexDirection: 'row',
          color: 't.black70',
          marginBottom: showDivider ? 'xs' : 'l',
          justifyContent: 'space-between',
        }}
      >
        <Flex sx={{ alignItems: 'center' }}>
          {icon && (
            <Box sx={{ marginRight: 'xs' }}>
              <FontAwesomeIcon icon={icon} fontSize="24" />
            </Box>
          )}
          <Box as="h3" sx={{ fontSize: 'H500', fontWeight: 'semiBold' }}>
            {title}
          </Box>
          {editable && (
            <Flex
              sx={{
                alignItems: 'center',
                gap: 'xxs',
                marginLeft: 's',
                color: 't.blue700',
                cursor: 'pointer',
              }}
              onClick={() => onEditClick?.()}
            >
              <div>
                <FontAwesomeIcon icon={faPen} />
              </div>
              <span>Edit</span>
            </Flex>
          )}
        </Flex>
        {headerAside}
      </Flex>
      {showDivider && <Divider />}
      <Flex sx={{ flexDirection: 'column', gap: 'l' }}>
        <div data-testid="section-content">{children}</div>
      </Flex>
    </Flex>
  );
};

export default RcsSectionBlock;
